/**
 * Freccia "scorri giù" nel cassetto del carrello (snippets/cart-drawer.liquid).
 * Sta sul bordo superiore del riepilogo fisso, a destra. Visibile solo se nell'area che scorre
 * (.cart-drawer__items) c'è altro contenuto sotto; sparisce quando si arriva in fondo.
 * Al tocco scorre di circa una schermata. Ricontrolla all'apertura del cassetto (resize del riepilogo),
 * a ogni scroll e dopo i ridisegni del carrello (il contenuto viene sostituito).
 */
class CartScrollCue extends HTMLElement {
  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    document.addEventListener('scroll', this.#onScroll, { capture: true, passive: true });
    this.#resizeObserver = new ResizeObserver(() => this.#update());
    if (this.parentElement) this.#resizeObserver.observe(this.parentElement);
    const scroller = this.#scroller;
    if (scroller) this.#resizeObserver.observe(scroller);
    this.querySelector('button')?.addEventListener('click', this.#scrollDown);
    this.#update();
  }

  disconnectedCallback() {
    document.removeEventListener('scroll', this.#onScroll, { capture: true });
    this.#resizeObserver?.disconnect();
  }

  /** L'area che scorre viene ricercata ogni volta: il carrello ridisegnato la sostituisce. */
  get #scroller() {
    return /** @type {HTMLElement | null} */ (
      this.closest('.cart-drawer__content')?.querySelector('.cart-drawer__items') ?? null
    );
  }

  #onScroll = (/** @type {Event} */ event) => {
    if (event.target instanceof Element && event.target.matches('.cart-drawer__items')) this.#update();
  };

  #update() {
    const scroller = this.#scroller;
    if (!scroller || scroller.clientHeight === 0) {
      this.hidden = true;
      return;
    }
    const remaining = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight;
    this.hidden = remaining < 40;
  }

  #scrollDown = () => {
    const scroller = this.#scroller;
    if (!scroller) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scroller.scrollBy({ top: scroller.clientHeight * 0.7, behavior: reduced ? 'auto' : 'smooth' });
  };
}

if (!customElements.get('cart-scroll-cue')) {
  customElements.define('cart-scroll-cue', CartScrollCue);
}
